import React from 'react';
import {env, orgId, apiUrl, defaultErrorHandler} from '../../../context/context';
import queryParameterUtils from '../../../utils/query-parameter-utils';
import redirectUtils from '../../../utils/redirect-utils';
import uploadV1Client from '../../../infrastructure/acerill/upload-v1-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import Section from '../../../libs/react-components-admin/section/section';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import SuccessBox from '../../../libs/react-components-admin/box/success-box';
import ConnectedAccounts from '../common/connected-accounts';

class Dropbox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      oAuthSettings: null,
      accounts: null,
      successMessageCode: queryParameterUtils.tryFindQueryParameter('success_message_code'),
    };
  }

  componentDidMount() {
    Promise
      .all([
        uploadV1Client.findDropboxOAuthSettings(),
        uploadV1Client.findDropboxAccounts(),
      ])
      .then(result => this.setState({oAuthSettings: result[0], accounts: result[1]}))
      .catch(defaultErrorHandler);
  }

  connectAccount(accountName) {
    const state = 'custom-forms%3B' + encodeURIComponent(orgId) + '%3B' + encodeURIComponent(accountName);
    const url = env === 'local' ?
      apiUrl + '/upload/v1/public/dropbox/oauth?state=' + state :
      'https://www.dropbox.com/oauth2/authorize' +
      '?client_id=' + encodeURIComponent(this.state.oAuthSettings.clientId) +
      '&redirect_uri=' + encodeURIComponent(this.state.oAuthSettings.redirectUrl) +
      '&response_type=code&token_access_type=offline' +
      '&state=' + state;
    return redirectUtils.redirectTo(url);
  }

  deleteAccount(id) {
    return uploadV1Client.deleteDropboxAccount(id)
      .then(() => this.setState(prevState => ({
        accounts: prevState.accounts.filter(a => a.id !== id),
      })));
  }

  successMessage() {
    return 'Dropbox integration successfully setup. From now on, all files will be uploaded to Dropbox.';
  }

  render() {
    return <Section title="Integration - Dropbox" noMargin={true}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          {this.state.successMessageCode &&
          <SuccessBox align="center">{this.successMessage(this.state.successMessageCode)}</SuccessBox>
          }
          <SubSection title="Connected accounts" className="mb-4" noMargin={true}>
            {(!this.state.oAuthSettings || !this.state.accounts) ?
              <CenteredSpinner/> :
              <ConnectedAccounts accounts={this.state.accounts}
                                 maxAccounts={1}
                                 connectAction={accountName => this.connectAccount(accountName)}
                                 deleteAction={id => this.deleteAccount(id)}
                                 errorHandler={defaultErrorHandler}/>
            }
          </SubSection>
        </div>
      </div>
    </Section>;
  }

}
export default Dropbox;
